function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgChatbubbleUnread = function SvgChatbubbleUnread(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: "new 0 0 20 20"
    },
    xmlSpace: "preserve"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M14 3c0-.6.1-1.2.4-1.7C13.1.8 11.6.5 10 .5 4.5.4 0 4 0 8.4s4.5 8 10 8c.9 0 1.8-.1 2.7-.3.2-.1.5 0 .7.1l5.2 2.7c.4.2.8-.1.7-.6l-1.1-4.7c-.1-.3 0-.6.2-.9 1-1.2 1.6-2.7 1.6-4.3 0-.6-.1-1.2-.3-1.8-.5.3-1.1.4-1.7.4-2.2 0-4-1.8-4-4zm4 2c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2z",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd"
    }
  }));
};
export default SvgChatbubbleUnread;